import {ApplicationConfig, inject, provideZonelessChangeDetection} from "@angular/core";
import {
  provideRouter,
  TitleStrategy,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling
} from "@angular/router";
import {tcRoutes} from "./tc.routes";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr} from "@angular/common/http";
import {providePrimeNG} from "primeng/config";
import {provideIndexedDb} from "ngx-indexed-db";
import {dbConfig} from "./tc.db.config";
import {AuthInterceptor} from "./app/core/interceptors/auth.interceptor";
import {ErrorsInterceptor} from "./app/core/interceptors/errors.interceptor";
import {
  API_DATE_FORMAT,
  DATE_FORMAT,
  DATE_FORMAT_WITHOUT_DOTS,
  DATE_TIME_FORMAT,
  SMALL_DATE_FORMAT,
  TIME_SECOND_FORMAT
} from "./tc.tokens";
import {CustomTitleStrategy} from "./app/shared/services/custom-title-strategy";
import Aura from "@primeuix/themes/aura";
import {ConfirmationService, MessageService} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {provideEchartsCore} from "ngx-echarts";
import {provideMonacoEditor} from "ngx-monaco-editor-v2";

export const tcAppConfig: ApplicationConfig = {
  providers: [
    provideRouter(tcRoutes, withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled'
    }), withEnabledBlockingInitialNavigation()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideZonelessChangeDetection(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.app-dark',
          cssLayer: false,
          cssVariables: true,
        }
      },
      pt: {
        panel: {
          content: {
            class: 'pt-4!'
          }
        }
      },
      overlayAppendTo: 'body',
      license: 'eyJpZCI6IjI3ODQ5ZWRiLWFmMTctNGEwNi1iY2U1LWZlMGNjMTk2NjRmMiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODM3MTE4MTEsImV4cCI6MTgxNTI0NzgxMX0.8-NJQAlaVh-KA_SIX8RCmH6vPsOThI9BY5tx4jhsvlvVPcFn5ZZ0JlfP-9ksghPLl4Jt2y_kaB8y06MBqzvzBw',
      translation: {
        monthNames: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
      }
    }),
    provideIndexedDb(dbConfig),
    provideEchartsCore({echarts: () => import('./app/shared/echarts').then(m => m.echarts)}),
    provideMonacoEditor(),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true},
    {provide: DATE_TIME_FORMAT, useValue: 'dd.MM.yyyy \'в\' HH:mm'},
    {provide: DATE_FORMAT, useValue: 'dd.MM.yy'},
    {provide: DATE_FORMAT_WITHOUT_DOTS, useValue: 'dd MM yy'},
    {provide: SMALL_DATE_FORMAT, useValue: 'MMM dd'},
    {provide: API_DATE_FORMAT, useValue: 'yyyy-MM-dd'},
    {provide: TIME_SECOND_FORMAT, useValue: 'HH:mm:ss'},
    {provide: TitleStrategy, useFactory: () => inject(CustomTitleStrategy)},
    MessageService,
    ConfirmationService,
    DialogService
  ]
}
